import React, { useMemo } from 'react';
import TreeCheck from '../../../../../../../components/TreeCheck';
import {
  useLoadTreeData,
  generateDataForTree,
} from '../../../../../shared/lib/treeAddressesUtils';
import useAddressesTreeDataNew from '../../../../../shared/hooks/useAddressesTreeDataNew';
import { Spin } from 'antd';
import useFlatsByCompany from '../../api/useFlats';

const Content = ({ shutdown }) => {
  const companyId = shutdown?.serviceCompany?.id;

  const cityId = shutdown?.alertCity?.id;

  const { treeData, setTreeData, loading } = useAddressesTreeDataNew({
    cityId,
    companyId,
  });

  const { data: flats = {}, isFetching: isFetchingFlats } = useFlatsByCompany(
    companyId,
    {
      enabled: Boolean(companyId),
      select: (data) => {
        return Object.entries(data).reduce((acc, [key, value]) => {
          acc[key] = Array.isArray(value) ? value.map((item) => item.id) : [];

          return acc;
        }, {});
      },
    }
  );

  const initData = useMemo(
    () => generateDataForTree(shutdown, companyId, flats),
    [shutdown, companyId, flats]
  );

  const isFetching = isFetchingFlats;

  const onLoadData = useLoadTreeData({
    treeData,
    setTreeData,
    cityId,
    initValues: {
      houseIds: initData.houseIds,
      addressIds: initData.addressIds,
    },
  });

  return (
    <Spin spinning={isFetching}>
      <TreeCheck
        treeData={treeData}
        loadData={onLoadData}
        loading={loading}
        checkable={false}
        checkedKeys={initData.checkedKeys}
        halfCheckedKeys={initData.halfCheckedKeys}
      />
    </Spin>
  );
};

export default Content;
